<div class="modal">
  <div class="modal-content">
    <div class="modal-close">
      <button type="button" (click)="handleClose()">&#10799;</button>
    </div>
    <ng-content></ng-content>
  </div>
</div>
